import { DefaultLayout } from 'layouts';
import { useSelector } from 'react-redux';
import { userSelector, permissionSelector } from 'redux/userSlice';
import { SplashPage } from "pages";
import { EmptyState } from 'layouts';
import { MeasurementsEntryView, MeasurementsFileEntryView } from 'components';


const MeasurementsEntryPage = ({ file }) => {
    return <EmptyState component={file ? <MeasurementsFileEntryView /> : <MeasurementsEntryView />} />;
}

const MeasurementsEntryPageComponent = ({ file }) => {
    const createMeasurementPermission = useSelector((state) => permissionSelector(state, 'create-measurement'));
    const updateMetricPermission = useSelector((state) => permissionSelector(state, 'update-metric'));
    const { isSuccess: loggedIn } = useSelector(userSelector);

    if (loggedIn && (createMeasurementPermission || updateMetricPermission)) return <DefaultLayout page={<MeasurementsEntryPage file={file} />} />;
    else return <SplashPage />;
};

export default MeasurementsEntryPageComponent;